// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"_02712f2b3b--modal-content--lBWu9","aside":"_02712f2b3b--aside--s5V1x"};